import { render } from "./LeagueRankingView.vue?vue&type=template&id=323e224c&scoped=true"
import script from "./LeagueRankingView.vue?vue&type=script&lang=js"
export * from "./LeagueRankingView.vue?vue&type=script&lang=js"

import "./LeagueRankingView.vue?vue&type=style&index=0&id=323e224c&lang=scss"
import "./LeagueRankingView.vue?vue&type=style&index=1&id=323e224c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-323e224c"]])

export default __exports__